import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchBylawsQuery } from '#/api/hooks/useBylaws';
import { fetchCompanyGuarantorsQuery } from '#/api/hooks/useCompanyGuarantors';
import { fetchCompanyInfoQuery } from '#/api/hooks/useCompanyInfo';
import { fetchCompanyUsersQuery } from '#/api/hooks/useCompanyUsers';
import { fetchExternalUserInfoQuery } from '#/api/hooks/useUserInfo';
import type { InferLoaderData } from '#/routes/types';

export type LoaderData = InferLoaderData<typeof loader>;

export type Params = Record<string, string | undefined>;

export const id = 'organizationPage' as const;

async function loader({ params }: { params: Params }) {
  assertParamsPrescence(params);

  const data = await handleSettledPromises([
    fetchCompanyInfoQuery(),
    fetchCompanyUsersQuery(),
    fetchExternalUserInfoQuery(),
    fetchBylawsQuery(),
    fetchCompanyGuarantorsQuery(),
  ]);

  assertNoLoaderErrors(id, data);

  const [companyInfo, companyUsers, userInfo, bylaws, companyGuarantors] = data;
  return { companyInfo, companyUsers, userInfo, bylaws, companyGuarantors };
}

export const useOrganizationPageLoaderData = () => useRouteLoaderData(id);

export default loader;
